<div
  class="panel bg-white color-endeavour p-sm xl:p-md mx-sm xl:mx-md"
  [ngClass]="{'p-sm xl:p-md mx-sm xl:mx-md': !noPadding}"
>
  <ng-content></ng-content>
</div>
